import cartesIcon from '../assets/icons/map.png';
import satelliteIcon from '../assets/icons/satellite.png';
import geovisualisationIcon from '../assets/icons/globe.png';
import datavisualisationIcon from '../assets/icons/graphe.png';
import photographiesIcon from '../assets/icons/photo.png';
import dessinsIcon from '../assets/icons/draw.png';
import videosIcon from '../assets/icons/video.png';
import sonsIcon from '../assets/icons/sounds.png';
import mapLogo from '../assets/logo/map.png';
import satLogo from '../assets/logo/sat.png';
import geoLogo from '../assets/logo/geo.png';
import dataLogo from '../assets/logo/data.png';
import photoLogo from '../assets/logo/photo.png';
import drawLogo from '../assets/logo/dessin.png';
import videoLogo from '../assets/logo/video.png';
import sonLogo from '../assets/logo/son.png';

export const menuItems = [
    {
        icon: cartesIcon,
        label: "Cartes",
        logo: mapLogo
    },
    {
        icon: satelliteIcon,
        label: "Images satellites",
        logo: satLogo
    },
    {
        icon: geovisualisationIcon,
        label: "Géovisualisations",
        logo: geoLogo
    },
    {
        icon: datavisualisationIcon,
        label: "Datavisualisation",
        logo: dataLogo
    },
    {
        icon: photographiesIcon,
        label: "Photographies",
        logo: photoLogo
    },
    {
        icon: dessinsIcon,
        label: "Dessins",
        logo: drawLogo
    },
    {
        icon: videosIcon,
        label: "Vidéos",
        logo: videoLogo
    },
    {
        icon: sonsIcon,
        label: "Sons",
        logo: sonLogo
    },
];